import {mapFieldContract} from '../../core/fieldContract';

/**
 * Convert the Access Point field contract to existing Canvas form state.
 * @param {object} values canonical agent values
 * @return {object} safe form patch
 */
export function mapAccessPointPrefill(values = {}) {
	const contract = values?.__field_contract;
	if (contract?.resource !== 'ap') return {};
	return mapFieldContract(values, contract.mode === 'tip') || {};
}

/**
 * Convert the Access Point identity contract to the dashboard name editor.
 * @param {object} values canonical agent values
 * @return {object} safe identity patch
 */
export function mapAccessPointEditPrefill(values = {}) {
	const patch = mapAccessPointPrefill(values);
	return typeof patch.ap_name === 'string' && patch.ap_name.trim()
		? {ap_name: patch.ap_name.trim()}
		: {};
}

/**
 * Convert the Access Point identity contract to the Configure form.
 *
 * Renaming an Access Point opens the Configure form, whose name control is
 * `accessPointName` - while the catalogue's rename field binds to `ap_name`,
 * the name the dashboard header edits. Both are the same name, so whichever
 * arrives is put where this form keeps it.
 *
 * @param {object} values canonical agent values
 * @return {object} safe Configure form patch
 */
export function mapAccessPointConfigurePrefill(values = {}) {
	const patch = mapAccessPointPrefill(values);
	const name = [patch.accessPointName, patch.ap_name]
		.map((value) => (typeof value === 'string' ? value.trim() : ''))
		.find(Boolean);
	return name ? {accessPointName: name} : {};
}
